import type { CarespaceRecord } from "./carespaceRecords";
import {
  carespaceRefs,
  eligibleByCounty,
  hsaByMonth,
  hsaByProviderGroup,
  hsaClockBetween,
  referralsByProviderGroup,
  summarizeHsa,
  summarizeReferrals,
} from "./respiteMetrics";
import type { RespiteSummaryResponse } from "./respiteTypes";

/** Everything the page shows, derived once from the summary's records. */
export function respiteView(summary: RespiteSummaryResponse) {
  const inWindow = hsaClockBetween(summary.hsaRecords, summary.dateStart, summary.dateEnd);
  const records: CarespaceRecord[] = carespaceRefs(
    summary.hsaRecords,
    summary.referrals,
    summary.eligible,
    summary.missingInitialPaf,
  ).map(({ carespaceId, ...ref }) => ({ id: carespaceId, ...ref }));
  return {
    hsa: summarizeHsa(inWindow),
    /** The rolling headline: deadlines in the last 60 days. */
    due: summarizeHsa(
      hsaClockBetween(summary.hsaRecords, summary.toDate.clockFrom, summary.toDate.clockTo),
    ),
    months: hsaByMonth(inWindow),
    hsaGroups: hsaByProviderGroup(inWindow),
    referrals: summarizeReferrals(summary.referrals),
    referralGroups: referralsByProviderGroup(summary.referrals),
    counties: eligibleByCounty(summary.eligible),
    records,
  };
}

export type RespiteView = ReturnType<typeof respiteView>;
